import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { ActionsIcon } from '../../../../../assets/svg/actions';
import { Chip } from '../../../../../components/chip/chip';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { InfiniteScroll } from '../../../../../components/infinite-scroll/infinite-scroll';
import { Label } from '../../../../../components/label/label';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Tooltip } from '../../../../../features/tooltip/tooltip';
import { buildParams, concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { FormPath, ManagerPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { useFormStore } from '../../../../../store/use-form-store';
import { elementsRecord } from '../forms-helpers';
import s from './forms-cards.module.css';

export const FormsCards = () => {
  const { list, isLoadingFetch } = useFormStore();

  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  if (!list?.length && !isLoadingFetch) {
    return <div>{t('Здесь пока нет форм')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => {
        return (
          <li key={item.uuid} className={s.item}>
            <div className={s.top}>
              <span>{getLocale(item.name)}</span>

              <HasAccess service="form" permissions={['write']}>
                {item.is_deleted ? (
                  <IconButton
                    tooltip={t('Восстановить')}
                    variant="secondary"
                    size="sm"
                    onClick={() =>
                      addQueryParams({
                        restoreId: item.uuid,
                        restoreName: getLocale(item.name),
                      })
                    }
                  >
                    <TbRestore />
                  </IconButton>
                ) : (
                  <Tooltip
                    triggerWrapperClassName={s.actionsButton}
                    optionsWrapperClassName={s.actions}
                    trigger={<ActionsIcon />}
                    offset={12}
                  >
                    <div className={s.actions}>
                      <Link
                        to={
                          concatPath([RootPath.Manager, ManagerPath.Form, FormPath.Create]) +
                          buildParams({ id: item.uuid })
                        }
                      >
                        <IconButton tooltip={t('Редактировать')} size="sm" variant="secondary">
                          <AiOutlineEdit />
                        </IconButton>
                      </Link>

                      <IconButton
                        tooltip={t('Удалить')}
                        size="sm"
                        variant="secondary"
                        onClick={() =>
                          addQueryParams({
                            deleteId: item.uuid.toString(),
                            deleteName: getLocale(item.name),
                          })
                        }
                      >
                        <AiOutlineDelete />
                      </IconButton>
                    </div>
                  </Tooltip>
                )}
              </HasAccess>
            </div>

            <div className={s.main}>
              <Label className={s.label}>{t('Элементы')}</Label>
              <ul className={s.elements}>
                {item.elements.length
                  ? item.elements.map((item) => (
                      <Chip variant="info">{elementsRecord[item.type!]}</Chip>
                    ))
                  : t('Элементы формы не добавлены')}
              </ul>
            </div>
          </li>
        );
      })}

      <InfiniteScroll onEnterView={() => {}} />
    </ul>
  );
};
